import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import React from 'react'
import SecureEnrolmentHistoryMixedHandler from '../../containers/mixedHandlers/cardData/3DSecureHistory/enrolment/3DSecureEnrolmentHistoryMixedHandler';
import History3DSecureTelUpdateMixedHandler from '../../containers/mixedHandlers/cardData/3DSecureHistory/updatePhone/History3DSecureTelUpdateMixedHandler';
import History3DSecureStatusUpdateMixedHandler from '../../containers/mixedHandlers/cardData/3DSecureHistory/updateStatus/History3DSecureStatusUpdateMixedHandler';

const tabHeaders = ["Historique enrollement 3DSecure", "Historique MAJ Statut 3DSecure", "Historique MAJ Téléphone 3DSecure"];

const SecureHistory3DPage = () => {

    const tabContents = React.useMemo(() => (
        [
            <>
                <Heading size="md" mb={"2rem"}>Historique Enrollement 3DSecure des Cartes VISA</Heading>
                <SecureEnrolmentHistoryMixedHandler />
            </>,
            <>
                <Heading size="md" mb={"2rem"}>Historique MAJ Statut 3DSecure des Cartes VISA</Heading>
                <History3DSecureStatusUpdateMixedHandler />
            </>,
            <>
                <Heading size="md" mb={"2rem"}>Historique MAJ Tel 3DSecure des Cartes VISA</Heading>
                <History3DSecureTelUpdateMixedHandler />
            </>,
        ]
    ), [SecureEnrolmentHistoryMixedHandler, History3DSecureStatusUpdateMixedHandler, History3DSecureTelUpdateMixedHandler]);

  return (
    <>
        <CustomTabs tabContents={tabContents} tabHeaders={tabHeaders} />
    </>
  )
}

export default SecureHistory3DPage